/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * showcan API
 * OpenAPI spec version: 1.0.0
 */
import type { PublicVoiceAgentResponse } from "../../model";

import { customClient } from "../../custom-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get a voice AI agent by ID without authentication
 * @summary Get voice agent (public)
 */
export const getGetPublicVoiceAgentUrl = (id: string) => {
  return `/api/v1/public/voice-agents/${id}`;
};

export const getPublicVoiceAgent = async (
  id: string,
  options?: RequestInit,
): Promise<PublicVoiceAgentResponse> => {
  return customClient<PublicVoiceAgentResponse>(getGetPublicVoiceAgentUrl(id), {
    ...options,
    method: "GET",
  });
};
